import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";
import MetaTags from "react-meta-tags";
import { useHistory } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import { saveUser } from "../../redux/actions/userAction";
import { saveProducts } from "../../redux/actions/productsAction";
import { connect } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { Article, Prop } from "./animationList";
import ReactLoading from "react-loading";
import { submitForgotPassword } from "../../helpers/dbOperations";

  const ForgotPassword = ({setToken, saveUser, saveProducts}) => {
  const [email, setEmail] = useState();
  //const [username, setUserName] = useState();
  //const [password, setPassword] = useState();
  const [inCaricamento, setinCaricamento] = useState(false);
  let history = useHistory()

  const handleSubmit = async e => {
    submitForgotPassword(e, addToast, email, history)
  }

  const { addToast } = useToasts();
  var strings = require("../../translations/italian.json");
  var informazioni = global.informazioni

  return (
    <Fragment>
      <MetaTags>
        <title>Password dimenticata | {informazioni.titleSite}</title>
          <meta
            name="description"
            content= "Password dimenticata"
          />
      </MetaTags>

      <LayoutOne headerTop="invisible">
        {/* breadcrumb */}
        <Breadcrumb />
      

        <div className="login-register-area pt-100 pb-100">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 col-md-12 ml-auto mr-auto">
                <div className="login-register-wrapper">
                
                  <Tab.Container defaultActiveKey="login">
                    <Nav variant="pills" className="login-register-tab-list">
                      <Nav.Item>
                        <Nav.Link eventKey="login">
                          <h4>Password dimenticata</h4>
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content>
                      <Tab.Pane eventKey="login">
                        <div className="login-form-container">
                          <div className="login-register-form">
                            <form>
                              <p>
                                Inserisci l'indirizzo mail nel form qui sotto, ti invieremo una mail con la procedura per il ripristino
                              </p>
                              <input
                                type="text"
                                name="user-name"
                                placeholder="Email"
                                onChange={e => setEmail(e.target.value)}
                              />
                          
                              <div className="button-box">
                                <div className="login-toggle-btn">  
                                {!inCaricamento &&                             
                                  <button type ="button" onClick={handleSubmit}>
                                    <span>Reset password</span>
                                  </button>
                                }
                                {inCaricamento &&
                                  <Article key={"bars"}>
                                    <ReactLoading type={"bars"} color="black" />
                                    <Prop>{"Bars"}</Prop>
                                  </Article>  
                                }
                                </div>

                              </div>
                            </form>
                          </div>
                        </div>
                      </Tab.Pane>
                      
                    </Tab.Content>
                  </Tab.Container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};


ForgotPassword.propTypes = {
  location: PropTypes.object,
  setToken: PropTypes.func.isRequired,
  userData: PropTypes.object
};

const mapStateToProps = state => {
  return {
    user: state.user,
    products: state.productData.products,
    userData: state.userData
  };
};

const mapDispatchToProps = dispatch => {
  
  return {
      saveUser: (user, addToast) => {dispatch(saveUser(user, addToast))},
      saveProducts: (products, addToast) => {dispatch(saveProducts(products, addToast))}      
    
  };
};

//export default LoginRegister;
export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);